import { defineMessages } from 'react-intl';

export default defineMessages({
  uberVoucher: {
    id: 'src.pages.Uber.uberVoucher',
    defaultMessage: 'Uber Voucher',
  },
  howItWorks: {
    id: 'src.pages.Uber.howItWorks',
    defaultMessage: 'How it works:',
  },
  list1: {
    id: 'src.pages.Uber.list1',
    defaultMessage: 'Download the Uber app and create an account or use your existing account.',
  },
  list2: {
    id: 'src.pages.Uber.list2',
    defaultMessage: 'You’ll receive a text to the mobile number you provide with a link to your Uber Voucher.',
  },
  list3: {
    id: 'src.pages.Uber.list3',
    defaultMessage: 'Click on the link in the text and your voucher will be added to your ‘Wallet’ in the Uber app under the ‘Voucher’ section.',
  },
  list4: {
    id: 'src.pages.Uber.list4',
    defaultMessage: 'Your voucher will automatically be applied to your next ride.',
  },
  phoneNumberText: {
    id: 'src.pages.Uber.phoneNumberText',
    defaultMessage: 'Please provide your mobile number to receive your Uber Voucher:',
  },
  headsup: {
    id: 'src.pages.Uber.headsup',
    defaultMessage: 'Heads up!',
  },
  uberVouchers: {
    id: 'src.pages.Uber.uberVouchers',
    defaultMessage: 'Uber Vouchers have no cash value, do not apply to tips, or cover damage that may occur to a vehicle. Vouchers should only be used for ride sharing. Your personal payment method will be charged for any Uber Eats, grocery, or pick up orders.',
  },
  phoneError: {
    id: 'src.pages.Uber.phoneError',
    defaultMessage: 'Sorry! Your phone number must be 10 digits.',
  },
  phoneErrorStart1: {
    id: 'src.pages.Uber.phoneErrorStart1',
    defaultMessage: 'Oops! An area code cannot start with 1.',
  },
  getReady: {
    id: 'src.pages.Uber.getReady',
    defaultMessage: 'Get ready to ride',
  },
  uberText: {
    id: 'src.pages.Uber.uberText',
    defaultMessage: 'Uber will text you with a $XX voucher to',
  },
  uberContinueText1: {
    id: 'src.pages.Uber.uberContinueText1',
    defaultMessage: 'as soon as you click ',
  },
  uberContinueText2: {
    id: 'src.pages.Uber.uberContinueText2',
    defaultMessage: '‘Continue’',
  },
  uberContinueText3: {
    id: 'src.pages.Uber.uberContinueText3',
    defaultMessage: ' and your claim is submitted',
  },
  continueCta: {
    id: 'src.pages.Uber.continueCta',
    defaultMessage: 'Continue',
  },
  saveContinueCta: {
    id: 'src.pages.Uber.saveContinueCta',
    defaultMessage: 'Save & continue later',
  },
});
